import { SearchOutlined } from '@ant-design/icons';
import { Button, Input } from 'antd';
import React, { useState } from 'react';

function ExpandableSearchInput({
  placeholder, onChange, value, disabled,
}) {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleSearchClick = () => {
    setIsExpanded(true);
  };

  const handleInputBlur = () => {
    if (!value) {
      setIsExpanded(false);
    }
  };

  const handleInputChange = (e) => {
    onChange(e.target.value);
  };

  const handleClear = () => {
    onChange('');
    setIsExpanded(false);
  };

  if (!isExpanded) {
    return (
      <Button
        icon={<SearchOutlined />}
        onClick={handleSearchClick}
        size="large"
        disabled={disabled}
      />
    );
  }

  return (
    <Input
      placeholder={placeholder}
      value={value}
      onChange={handleInputChange}
      onBlur={handleInputBlur}
      onClear={handleClear}
      allowClear
      prefix={<SearchOutlined />}
      size="large"
      autoFocus
      className="min-w-[300px]"
      disabled={disabled}
    />
  );
}

export default ExpandableSearchInput;
